import { createSelector } from 'reselect';
const selectScribeSession = (state) => state.scribeSession;
export const selectScribeSessionBackends = createSelector([selectScribeSession], (scribeSession) => scribeSession.backends);
export const selectSelectedCaptions = createSelector([selectScribeSession], (scribeSession) => scribeSession.selectedCaptions);
export const selectDisplayable = createSelector([selectScribeSession], (scribeSession) => scribeSession.displayable);
export const selectBoostWords = createSelector([selectScribeSession], (scribeSession) => scribeSession.boostWords);
export const sidebarOpen = createSelector([selectScribeSession], (scribeSession) => scribeSession.sidebar);
